module.exports = __webpack_public_path__ + "img/1728960336823-bolu.jpg.ef94d9dd.webp";